<template>
  <TopBanner :warning="hasWarning">
    <div class="flex flex-col items-center">
      <IconLabel v-if="hasWarning" icon="varning">
        <template v-if="individStore.individ.data?.avliden!">Avliden</template>
        <template v-if="individStore.individ.data?.skyddadPersonuppgift!"
          >Skyddad identitet</template
        >
      </IconLabel>
      <TitleText>{{ formattedName }}</TitleText>
      <LabelItem>{{
        personnummerWithDash12Digits(individStore.individ.data?.personnummer)
      }}</LabelItem>
      <IdentifiedTag
        :identified="individStore.verification.isVerified"
        :manuallyIdentified="individStore.verification.isManuallyVerified"
        :isLoading="individStore.verification.isAuthenticating"
      />
    </div>
    <div class="absolute right-none z-20" id="bank-id-button">
      <BankId :personnummer="individStore.individ.data?.personnummer" />
    </div>
  </TopBanner>
</template>

<script setup lang="ts">
import { computed } from "vue";

import {
  IconLabel,
  IdentifiedTag,
  LabelItem,
  TitleText,
  TopBanner,
} from "@/components/top-banner";
import BankId from "@/components/verification/BankID.vue";
import { useIndividStore } from "@/stores";
import {
  formatIndividFullName,
  personnummerWithDash12Digits,
} from "@/common/formatters";

const individStore = useIndividStore();

const hasWarning = computed(
  () =>
    !!individStore.individ.data?.skyddadPersonuppgift ||
    !!individStore.individ.data?.avliden,
);
const formattedName = computed(() =>
  formatIndividFullName(individStore.individ.data),
);
</script>
